import errorStackParser from 'error-stack-parser';
import request from 'superagent';

global.window._sparcitRollbarOptions = {
  startTime: new Date().getTime(),
};

class Rollbar {
  constructor(logger) {
    this._logger = logger;

    this.setSessionId = this.setSessionId.bind(this);
    this.log = this.log.bind(this);
  }

  setSessionId(sessionId) {
    this.sessionId = sessionId;
  }

  /**
   * Sends logs to Rollbar, if enabled.
   *
   * Read more about rollbar api here https://rollbar.com/docs/api/items_post
   *
   * @param {Object} msg_or_err - Message text (String) or Javascript Error
   * @param {Object} options
   *                  @option {String} level - e.g. "critical", "error", "warning", "info", "debug"
   *                  @option {Error} error
   *                  @option {Object} state
   *                  @option {Object} req
   *                  @option {Object} res
   */
  log(msg_or_err, options = {}) {
    let message,
      error;

    if (typeof msg_or_err === 'string') {
      message = msg_or_err;
    } else {
      error = msg_or_err;
    }

    const data = this.__payload(
      message,
      error,
      options.level || 'info',
      options.state,
      options.req,
      options.res,
    );

    this._logger.log('Error data for Rollbar: ', data);
    if (ROLLBAR_ENABLED) {
      // do not report errors in development mode
      // trace
      const rollbarReq = request.post('https://api.rollbar.com/api/1/item/').send(data);

      rollbarReq.end(err => {
        if (err) {
          this._logger.log('Error report wasn\'t sent', err);
        }
      });
    } else {
      this._logger.log('Error is not reported. Rollbar is disabled.');
    }
  }

  /**
   * @param {String} message - Message text (String)
   * @param {Error} error - Javascript Error/Exception
   * @param {String} level
   * @param {Object} state
   * @return {Object} - data for Rollbar
   */
  __payload(message, error, level, state, req, res) {
    const server = {};
    const custom = {
      sessionId: this.sessionId,
      state: JSON.stringify(state), // stringify state for easier copy/paste
      req: req,
    };
    let body;
    const ts = new Date();

    if (res) {
      server.code_version = res.headers['xit-version'];
      custom.res = {
        unauthorized: res.unauthorized,
        status: res.status,
        body: res.body,
        headers: res.headers,
      };
    }

    if (error) {
      body = this.__buildBodyTrace(error);
    } else {
      body = this.__buildBodyMessage(message);
    }

    return {
      access_token: ROLLBAR_TOKEN,
      data: {
        environment: APP_ENV,
        timestamp: new Date().getTime(),
        level,
        platform: 'browser',
        language: 'javascript',
        body,
        client: {
          runtime_ms: ts.getTime() - global.window._sparcitRollbarOptions.startTime,
          timestamp: Math.round(ts.getTime() / 1000),
          javascript: {
            browser: global.window.navigator.userAgent,
            language: global.window.navigator.language,
            screen: {
              width: global.window.screen.width,
              height: global.window.screen.height,
            },
            plugins: this._getBrowserPlugins(),
            code_version: VERSION,
            source_map_enabled: true,
            guess_uncaught_frames: true,
          },
        },
        server,
        request: {
          url: global.window.location.href,
          query_string: window.location.search,
          user_ip: '$remote_ip',
        },
        custom,
        notifier: {
          name: 'xit-client',
          version: VERSION,
        },
      },
    };
  }

  __buildBodyMessage(_message) {
    return { message: { body: _message } };
  }

  __buildBodyTrace(error) {
    let frames = [];
    try {
      frames = errorStackParser.parse(error).map(frame => ({
        _stackFrame: frame,
        filename: frame.fileName,
        lineno: frame.lineNumber,
        colno: frame.columnNumber,
        method: frame.functionName,
        args: frame.args,
      }));
    } catch (e) {
      this._logger.log(`No stack trace for "${error.message}"`);
    }

    return {
      trace: {
        frames,
        exception: {
          class: error.name || '(unknown)',
          message: error.message,
        },
      },
    };
  }

  _getBrowserPlugins() {
    if (!this._browserPlugins) {
      const navPlugins = global.window.navigator.plugins || [];
      let cur;
      const numPlugins = navPlugins.length;
      const plugins = [];
      let i;
      for (i = 0; i < numPlugins; ++i) {
        cur = navPlugins[i];
        plugins.push({ name: cur.name, description: cur.description });
      }
      this._browserPlugins = plugins;
    }
    return this._browserPlugins;
  }
}

export default Rollbar;



// WEBPACK FOOTER //
// ./src/utils/Rollbar/index.js